import { Table } from '@weezevent/nacre';
import { React, useCallback, observer, main } from '../../..';
import { isInvalidEmail } from '../../../utils';
import Row from './Row';
import { useTranslation } from 'react-i18next';
import css from './table.module.css';
import QuotasExceeded from '../../QuotasExceeded';

const AttendeesTable = observer(() => {
    const { attendees, maxAttendees, event, invitationsQuotas } = main;
    const { t } = useTranslation();

    const onPaste = useCallback(
        event => {
            event.preventDefault();

            let clip = event.clipboardData.getData('Text');
            let row = clip.split('\n');
            let rows = [];
            let tab_name = ['lastname', 'firstname', 'quantity', 'email'];
            let paste_name = event.target.name;
            let paste_index = parseInt(event.target.dataset.id);

            row.forEach(r => {
                if (!r || !r.trim() || !r.replace(/\t/g, '').trim()) {
                    return;
                }
                let index = tab_name.findIndex(name => name === paste_name);
                let existingData = [];

                const pasted_data = r.split('\t');

                for (let i = 0; i < pasted_data.length; i++) {
                    existingData[index + i] = pasted_data[i];
                }
                rows.push(existingData);
            });

            for (let i = 0; i < rows.length && i < maxAttendees; i++) {
                const [lastname, firstname, quantity, email] = rows[i];
                const email_value = email ? email.trim() : main.attendees[paste_index].email;
                main.setPaste(paste_index + i, {
                    lastname: lastname ? lastname.trim() : main.attendees[paste_index].lastname,
                    firstname: firstname ? firstname.trim() : main.attendees[paste_index].firstname,
                    quantity: quantity ? quantity.trim() : main.attendees[paste_index].quantity,
                    email: email_value,
                    event_id: main.event.id,
                    channel_id: 0,
                    payment_type: 9,
                    valid: isInvalidEmail(email_value)
                });
            }

            main.attendees.forEach((attendee, index) => {
                let attendeeToParse = {
                    lastname: attendee.lastname,
                    firstname: attendee.firstname,
                    quantity: attendee.quantity,
                    email: attendee.email,
                    event_id: main.event.id,
                    rate_id: main.selectedRates[0]?.original_object.id,
                    channel_id: 0,
                    payment_type: 9,
                    valid: isInvalidEmail(attendee.email),
                    paid_price: 0,
                    form: {
                        ws_2: attendee.lastname,
                        ws_3: attendee.firstname,
                        ws_5: attendee.email
                    },
                    buyer_form: {
                        ws_2: attendee.lastname,
                        ws_3: attendee.firstname,
                        ws_5: attendee.email
                    }
                };

                main.setAttendees(index, attendeeToParse);
            });
        },
        [main, isInvalidEmail]
    );

    const onChange = useCallback(
        (index, key, value) => {
            let attendeeToParse = {
                lastname: attendees[index].lastname,
                firstname: attendees[index].firstname,
                quantity: attendees[index].quantity,
                email: attendees[index].email,
                event_id: event?.id,
                rate_id: main.selectedRates[0]?.original_object.id,
                channel_id: 0,
                payment_type: 9,
                valid: isInvalidEmail(attendees[index].email),
                paid_price: 0,
                form: {
                    ws_2: attendees[index].lastname,
                    ws_3: attendees[index].firstname,
                    ws_5: attendees[index].email
                },
                buyer_form: {
                    ws_2: attendees[index].lastname,
                    ws_3: attendees[index].firstname,
                    ws_5: attendees[index].email
                }
            };

            attendeeToParse[key] = value;

            if (key === 'email') {
                attendeeToParse['valid'] = isInvalidEmail(attendeeToParse['email']);
            }

            ['form', 'buyer_form'].forEach(field => {
                attendeeToParse[field]['ws_2'] = attendeeToParse['lastname'];
                attendeeToParse[field]['ws_3'] = attendeeToParse['firstname'];
                attendeeToParse[field]['ws_5'] = attendeeToParse['email'];
            });

            main.setAttendees(index, attendeeToParse);

            if (attendeeToParse.firstname || attendeeToParse.lastname || attendeeToParse.quantity || attendeeToParse.email) {
                if (index + 1 === attendees.length && index + 1 < maxAttendees) {
                    main.addRow({ lastname: undefined, firstname: undefined, quantity: undefined, email: undefined });
                }
            } else {
                if (index + 2 === attendees.length && attendees.length > 1) {
                    main.removeRow();
                }
            }
        },
        [main, attendees, event, isInvalidEmail]
    );

    return (
        <>
            {!invitationsQuotas && <QuotasExceeded />}
            <Table className={css['manual-table']}>
                <Table.Header>
                    <Table.Header.Row>
                        <Table.Header.Cell className={`${css['thead']} ${css['index']}`} />
                        <Table.Header.Cell className={`${css['thead']} ${css['infos']}`}>{t('attendees.invitations.table.lastName')}</Table.Header.Cell>
                        <Table.Header.Cell className={`${css['thead']} ${css['infos']}`}>{t('attendees.invitations.table.firstName')}</Table.Header.Cell>
                        <Table.Header.Cell className={`${css['thead']} ${css['qt']}`}>{t('attendees.invitations.table.quantity')}</Table.Header.Cell>
                        <Table.Header.Cell className={`${css['thead']}`}>{t('attendees.invitations.table.email')}</Table.Header.Cell>
                    </Table.Header.Row>
                </Table.Header>
                <Table.Body>
                    {attendees.map((attendee, index) => (
                        <Row key={index} index={index} onPaste={onPaste} attendee={attendee} onChange={(key, value) => onChange(index, key, value)} />
                    ))}
                </Table.Body>
            </Table>
        </>
    );
});
export default AttendeesTable;
